var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#FFEEE0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3225_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5319 15C42.2186 15 47.8779 20.1772 48.7437 27.0924C48.7801 27.3794 48.8388 27.6648 48.8578 27.9518C48.9229 28.9698 48.9181 28.9492 47.9382 28.9397C47.5354 28.9397 47.3657 28.8525 47.353 28.3799C47.185 22.5906 43.0321 17.4768 37.2048 16.6348C30.3325 15.6422 24.7224 20.7291 23.8471 26.9544C23.7805 27.4301 23.6711 27.89 23.7139 28.3657C23.7567 28.8414 23.5458 28.9286 23.1367 28.9333C22.1552 28.946 22.1552 28.9682 22.2107 27.9534C22.5595 21.5124 27.5909 15.926 33.7274 15.1411C34.3256 15.0588 34.9281 15.0117 35.5319 15Z",
    fill: "#FF8D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9867 55.5697C35.2208 55.5697 34.4565 55.5808 33.6906 55.5697C32.6996 55.5538 32.0637 54.9481 32.0273 53.9523C31.9987 53.1594 31.9987 52.3666 32.0273 51.5738C32.0622 50.5954 32.633 49.9881 33.6129 49.9659C35.2219 49.9289 36.8313 49.9289 38.4413 49.9659C39.3816 49.9865 39.8684 50.4622 39.9841 51.4247C40.0333 51.8449 40.1237 51.9924 40.5946 51.9654C41.6201 51.9202 42.6389 51.778 43.6375 51.5405C45.9558 50.9538 47.256 49.4299 47.6857 47.1164C47.7523 46.7533 47.8681 46.3791 47.8316 46.0239C47.7523 45.2422 48.0156 44.9995 48.8211 45.0091C49.3872 45.0091 49.4871 45.1359 49.4395 45.6433C49.3142 46.9579 49.1224 48.2549 48.569 49.468C47.3956 52.0304 45.1709 52.9866 42.5751 53.3497C41.8981 53.4449 41.213 53.4845 40.5296 53.521C40.2125 53.5384 40.0983 53.6256 40.0396 53.9681C39.8272 55.2097 39.3657 55.5713 38.1257 55.5744L35.9867 55.5697Z",
    fill: "#FF8D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.979 37.0126C23.979 39.0962 23.9647 41.1797 23.9901 43.2633C23.9901 43.739 23.8981 43.9357 23.3875 43.8849C22.877 43.8342 22.387 43.8849 21.8859 43.8532C20.1861 43.7707 19.0587 42.6941 19.0317 40.999C18.9894 38.3118 18.9894 35.6225 19.0317 32.931C19.0603 31.2613 20.1861 30.1973 21.9049 30.0626C23.9774 29.904 23.9774 29.904 23.9774 31.9463L23.979 37.0126Z",
    fill: "#FF8D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0189 36.9479C47.0189 34.8659 47.0364 32.7823 47.0078 30.7003C47.0078 30.1929 47.122 29.9947 47.6532 30.0486C48.3303 30.1152 49.0153 30.0026 49.6955 30.1755C51.1084 30.5354 51.9424 31.444 51.9646 32.9139C52.0058 35.6286 52.0169 38.3449 51.9646 41.0596C51.9313 42.7134 50.7896 43.7663 49.1342 43.8519C47.0237 43.9598 47.0237 43.9598 47.0237 41.8508L47.0189 36.9479Z",
    fill: "#FF8D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4151 27.9439C45.4151 22.4688 40.9766 18.0303 35.5015 18.0303C30.0264 18.0303 25.5879 22.4688 25.5879 27.9439V35.3173C25.5879 40.7925 30.0264 45.231 35.5015 45.231C40.9766 45.231 45.4151 40.7925 45.4151 35.3173V27.9439Z",
    fill: "#FF8D30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3225_1262",
    x: 12,
    y: 12,
    width: 47,
    height: 54.5742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.552941 0 0 0 0 0.188235 0 0 0 0.552941 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_1262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_1262",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.331a80dd33be57bc99f6c5c2e4a49f7d.svg";
export { ForwardRef as ReactComponent };